var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommitSha = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 9,
  viewBox: "0 0 19 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.25C0 3.83579 0.335786 3.5 0.75 3.5H18.25C18.6642 3.5 19 3.83579 19 4.25C19 4.66421 18.6642 5 18.25 5H0.75C0.335786 5 0 4.66421 0 4.25Z",
  fill: "#8E8E8E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 4.5C14 6.98528 11.9853 9 9.5 9C7.01472 9 5 6.98528 5 4.5C5 2.01472 7.01472 0 9.5 0C11.9853 0 14 2.01472 14 4.5Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5 7.5C11.1569 7.5 12.5 6.15685 12.5 4.5C12.5 2.84315 11.1569 1.5 9.5 1.5C7.84315 1.5 6.5 2.84315 6.5 4.5C6.5 6.15685 7.84315 7.5 9.5 7.5ZM9.5 9C11.9853 9 14 6.98528 14 4.5C14 2.01472 11.9853 0 9.5 0C7.01472 0 5 2.01472 5 4.5C5 6.98528 7.01472 9 9.5 9Z",
  fill: "#8A8A8A"
})));
export default SvgCommitSha;